module.exports = __webpack_public_path__ + "static/media/whatsapp-contato.41966353.svg";